import swapIcon from "../images/swapGoldIcon.svg";
import swapGoldBg1 from "../images/swapgoldBg1.svg";
import swapGoldBg2 from "../images/SwapGoldBg2.svg";
import exchangeCoin1 from "../images/exchangeCoin1.svg";
import exchangeCoin2 from "../images/SGOLD1.png";
import withdrawButton from "../images/withDrawButton.png";
import { FaArrowDown, FaChevronDown } from "react-icons/fa6";

const SwapGold = () => {
  return (
    <div className="   ">
      <section className="max-w-[1400px] mx-auto">
      <div className="flex items-center w-full my-5 ml-10">
        <img className="w-[82px]" src={swapIcon} alt="Swap Gold" />
        <div className="">
          <h3 className="text-2xl text-yellow-400 font-semibold">Swap Gold</h3>
          <p className="text-lg font-semibold">
            You Can Exchange your $SWCH to $SGOLD
          </p>
        </div>
      </div>
      <div className="flex justify-center items-center p-5 relative max-w-[1400px]  w-full h-auto ">
        <img
          className="hidden md:block absolute  left-10 bottom-16  w-[380px]"
          src={swapGoldBg1}
        />
        <div className="w-[100%] md:w-[500px]   relative bg-yellow-200/20 rounded-3xl z-10 backdrop-blur-sm border border-yellow-300 px-3   md:px-5 py-5">
          <h1 className="text-center text-3xl font-bold">
            Buy <span className="text-yellow-400">$SGOLD</span> Token
          </h1>
          <div className="bg-gray-400/20 mt-5 p-3 md:p-5 rounded-3xl">
            <div className="flex justify-between">
              <div className="flex flex-col justify-end items-start">
                <p>You pay</p>
                <h3 className="text-2xl md:text-3xl font font-semibold mt-2">
                  1535
                </h3>
              </div>
              <div className="flex justify-between flex-col items-end">
                <p>Balance: 2500</p>
                <button className="w-auto border-[1px] border-yellow-200 text-sm  bg-yellow-500/5 rounded-3xl mt-2 flex items-center p-2 ">
                  <img
                    className="mx-1"
                    src={exchangeCoin1}
                    alt=" "
                    width={"27px"}
                    height={"27px"}
                  />
                  <p className="">SWCH</p>
                  <FaChevronDown className="mx-2 text-lg" />
                </button>
              </div>
            </div>
            <div className="flex mt-2">
              <button className="w-[20%] hover:scale-105 transition-transform duration-300 text-center border-[1px] border-yellow-200 text-sm font-light  bg-yellow-400/5 rounded-3xl mt-2 mx-1 p-1 ">
                10%
              </button>
              <button className="w-[20%] hover:scale-105 transition-transform duration-300 text-center border-[1px] border-yellow-200 text-sm font-light bg-yellow-400/5 rounded-3xl mt-2 mx-1 p-2 ">
                25%
              </button>
              <button className="w-[20%] hover:scale-105 transition-transform duration-300 text-center border-[1px] border-yellow-200 text-sm font-light bg-yellow-400/5 rounded-3xl mt-2 mx-1 p-2 ">
                50%
              </button>
              <button className="w-[20%] hover:scale-105 transition-transform duration-300 text-center border-[1px] border-yellow-200 text-sm font-light bg-yellow-400/5 rounded-3xl mt-2 mx-1 p-2 ">
                75%
              </button>
              <button className="w-[20%] hover:scale-105 transition-transform duration-300 text-center border-[1px] border-yellow-200 text-sm font-light  bg-yellow-400/5 rounded-3xl mt-2 mx-1 p-2 ">
                100%
              </button>
            </div>
          </div>
          <div className="bg-yellow-400 w-fit p-2 rounded-full absolute b left-[46%] top-[45%] border-[3px] border-gray-800 ">
            <FaArrowDown className="text-black" />
          </div>
          <div className="bg-gray-400/20 mt-3 p-5 rounded-3xl">
            <div className="flex justify-between">
              <div className="flex flex-col justify-end items-start">
                <p>You Receive</p>
                <h3 className="text-2xl md:text-3xl font font-semibold mt-2">
                  3500
                </h3>
              </div>
              <div className="flex justify-between flex-col items-end">
                <p>Balance: 350</p>
                <button className="w-auto border-[1px] border-yellow-200 text-sm font-semibold bg-yellow-500/5 rounded-3xl mt-2 flex items-center p-2 ">
                  <img
                    className="mx-1"
                    src={exchangeCoin2}
                    alt=" "
                    width={"27px"}
                    height={"27px"}
                  />
                  <p className="">SWCH</p>
                  <FaChevronDown className="mx-2 text-lg" />
                </button>
              </div>
            </div>
            <div className="flex mt-2">
              <p>Min. receive : 3496.30</p>
            </div>
          </div>
          <div>
            <h3 className="text-yellow-400 text-center mt-3 font-semibold text-lg">
              1 SWCH = 20.56 SGOLD
            </h3>
            <button className="bg-gradient-to-r hover:bg-gradient-to-b transition-colors duration-300 from-yellow-400 to-yellow-500 p-3 rounded-3xl w-full mt-3 text-gray-800 font-semibold">
              Connect Wallet
            </button>
          </div>
        </div>

        <img
          className="hidden md:block absolute right-16 top-16 w-[343px]"
          src={swapGoldBg2}
        />
      </div>
      <div className="flex flex-col w-full  items-center mt-[-40px] ">
        <button className="w-[300px] hover:scale-105 transition-transform duration-300 z-0">
          <img src={withdrawButton} />
        </button>
        <p className="pb-4 text-yellow-400 mt-[-33px] z-10">Your Balance : 2367500.00</p>
      </div>
      <div className="flex justify-center mb-8">
        <img className="block md:hidden w-[312px]" src={swapGoldBg2} />
      </div>
      </section>
    </div>
  );
};

export default SwapGold;
